import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", {}), /* @__PURE__ */ _jsx("line", {
		x1: -11.0607,
		y1: 41.9393,
		x2: 41.9393,
		y2: -11.0607,
		stroke: "#E91D2E",
		strokeWidth: 3
	})]
});
export default SvgIconNone;
